import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { Image, SVGIcon, Button } from 'components/qstrap'

const Explanation = ({ factor }) => {
  if (factor === 'riasec') {
    // Riasec Explanation
    // ================================================
    return (
      <div className="m-t-md">
        {
          [
            intl.get('aptitude.questions.bar.riasec.answer.1'),
            intl.get('aptitude.questions.bar.riasec.answer.2'),
            intl.get('aptitude.questions.bar.riasec.answer.3'),
            intl.get('aptitude.questions.bar.riasec.answer.4'),
            intl.get('aptitude.questions.bar.riasec.answer.5'),
          ].map((text, index) => (
            <div key={text} className="m-b-md">
              <Image src={`/assets/img/riasec_emoji/${index + 1}/color.svg`} />
              <span className="m-l-lg">{text}</span>
            </div>
            ))
        }
      </div>
    )
  }
  // Charcs Explanation
  // ================================================
  return (
    <div className="m-y-md">
      <div>
        <Button className="charcs-btn m-r-md" size="sm">
          <div><SVGIcon name="common-back" size="sm" /><SVGIcon name="common-back" /></div>
        </Button>
        <small><b>{intl.get('aptitude.questions.bar.charcs.answer.1')}</b></small>
      </div>
      <div>
        <Button className="charcs-btn m-r-md" size="sm">
          <SVGIcon name="common-back" />
        </Button>
        <small><b>{intl.get('aptitude.questions.bar.charcs.answer.2')}</b></small>
      </div>
      <div>
        <Button className="charcs-btn m-r-md" size="sm">
          <SVGIcon name="common-next" />
        </Button>
        <small><b>{intl.get('aptitude.questions.bar.charcs.answer.3')}</b></small>
      </div>
      <div>
        <Button className="charcs-btn m-r-md" size="sm">
          <div><SVGIcon name="common-next" /><SVGIcon name="common-next" size="sm" /></div>
        </Button>
        <small><b>{intl.get('aptitude.questions.bar.charcs.answer.4')}</b></small>
      </div>
    </div>
  )
}

Explanation.propTypes = {
  factor: PropTypes.string.isRequired,
}

export default Explanation
